import BasePlugin from "../base/BasePlugin";
import EcmoEmrStore from "data/EcmoEmrStore";

export default class EcmoEmrPlugin extends BasePlugin {
    initialize(options) {
        super.initialize(options);

        this.set("name", "EcmoEmr");
        this.set("id", "ecmoemr");
        this.set("fluxContext", "CTX_MappingPlugin_EcmoEmr");

        this.set("fields", [
            {key: "mrn", type: "string", name: "Medical Record Number"}
        ]);
    }

    hasPaginationParams() {
        return true;
    }

    getPagination(query) {
        return EcmoEmrStore.getPagination(query);
    }

    getQueryLO(query, initiate, interactive) {
        return initiate
            ? EcmoEmrStore.getHotLO(query, interactive)
            : EcmoEmrStore.getColdLO(query);
    }

    getButtonListingPrefix() {
        return "Map From ECMO EMR Record ";
    }
}



// WEBPACK FOOTER //
// ./app/lib/mapping/sources/ecmoemr/EcmoEmrPlugin.js